import './styles/main.css'
import Main from './components/main'
import MetaTags from './components/MetaTags';

function App() {
	return (
		<div className="App">
			<MetaTags />
			<Main />
		</div>
	);
}

export default App;
